import { Link } from "react-router-dom";
import "./button.scss";

export default function Button({ children, extra_classes, ...props }) {
	
	const Tag = props.href ? "a" : props.to ? Link : "button";
	const className = [ "btn", extra_classes || "" ].join( " " ); 

	return <Tag className={ className } {...props }> { children } </Tag>
}